import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { message } from 'antd';
import { ticketStatusList, statusList, typeEnums } from './constants';
import { ApprovalStatus } from './type';

const model = {
  state: {
    queryParams: {
      per_page: 10,
      cur_page: 1,
      status: '',
      approvalStatus: ApprovalStatus.ALL,
    },
    listLoading: false,
    tableList: [],
    listTotal: 0,
    addNumId: null,
    addNumVisible: false,
    detailVisible: false,
    detailList: [],
    detailListTotal: 0,
    detailListLoading: false,
    detailParams: {
      per_page: 20,
      cur_page: 1,
      type: 'all',
    },
    addEditType: 'add',
    rangeData: [],
    rangeDataFetching: false,
    peopleData: [],
    peopleDataFetching: false,
    couponData: [],
    couponDataFetching: false,
    initData: {},
    couponResNum: {}, // 优惠券剩余张数
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { marketingLaunchManage }, getState }) => ({
    // 获取优惠券列表
    async getList() {
      const { union_shop_id, shop_id } = getState().basic;
      const { queryParams } = getState().marketingLaunchManage;
      const { per_page, cur_page, status, releaseId, releaseName, approvalStatus } = queryParams;
      marketingLaunchManage.setState({ listLoading: true });
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/releaselist', {
        type: 'POST',
        useJson: true,
        params: filterNull({
          status,
          releaseId,
          releaseName,
          unionShopId: union_shop_id,
          shopId: shop_id,
          pageNum: cur_page,
          pageSize: per_page,
          approvalStatus,
        }),
      });
      marketingLaunchManage.setState({ listLoading: false });
      if (data) {
        marketingLaunchManage.setState({
          tableList: data.records,
          listTotal: data.total,
        });
      }
    },
    // 搜索
    onSearch(queryParams) {
      marketingLaunchManage.setState({ queryParams });
      marketingLaunchManage.getList();
    },
    // 重置筛选项
    onReset() {
      marketingLaunchManage.setState({
        queryParams: {
          per_page: 10,
          cur_page: 1,
          status: '',
          approvalStatus: ApprovalStatus.ALL,
        },
      });
    },
    // 翻页
    onNav(page) {
      const { queryParams } = getState().marketingLaunchManage;
      marketingLaunchManage.setState({ queryParams: { ...queryParams, cur_page: page } });
      marketingLaunchManage.getList();
    },
    // 加大投放
    async onAddNum(values) {
      const { union_shop_id, shop_id } = getState().basic;
      const { addNumId } = getState().marketingLaunchManage;
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/addreleasenum', {
        type: 'GET',
        params: { ...values, unionShopId: union_shop_id, shopId: shop_id, releaseId: addNumId },
      });
      if (data) {
        marketingLaunchManage.getList();
        marketingLaunchManage.setAddNumVisible(false);
        message.success('加大投放成功');
      }
    },
    setAddNumVisible(visible) {
      marketingLaunchManage.setState({ addNumVisible: visible });
    },
    setAddNumId(id) {
      marketingLaunchManage.setState({ addNumId: id });
    },
    setQueryParams(params) {
      const { queryParams } = getState().marketingLaunchManage;
      marketingLaunchManage.setState({ queryParams: { ...queryParams, ...params } });
    },
    // 停止
    async onDisable(releaseId) {
      const { union_shop_id, shop_id } = getState().basic;
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/releasestop', {
        type: 'GET',
        params: {
          unionShopId: union_shop_id,
          shopId: shop_id,
          releaseId,
          // status: statusList.find((status) => status.label === '失效').id,
        },
      });
      if (data) {
        marketingLaunchManage.getList();
        message.success('停止投放成功');
      }
    },
    // 详情
    async getDetail(releaseId) {
      const { union_shop_id, shop_id } = getState().basic;
      const { detailParams } = getState().marketingLaunchManage;
      marketingLaunchManage.setState({ detailListLoading: true });
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/releasedetail', {
        type: 'GET',
        params: filterNull({
          type: ticketStatusList[detailParams.type].key,
          unionShopId: union_shop_id,
          shopId: shop_id,
          releaseId,
          pageNum: detailParams.cur_page,
          pageSize: detailParams.per_page,
        }),
      });
      if (data) {
        marketingLaunchManage.setState({
          detailList: data.records,
          detailListTotal: data.total,
        });
      }
      marketingLaunchManage.setState({ detailListLoading: false });
    },
    async exportDetail(id, setLogListDot) {
      const { union_shop_id, shop_id } = getState().basic;
      const { detailParams } = getState().marketingLaunchManage;
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/releasedetail/export', {
        type: 'GET',
        params: filterNull({
          type: ticketStatusList[detailParams.type].key,
          releaseId: id,
          unionShopId: union_shop_id,
          shopId: shop_id,
        }),
      });
      if (data) {
        message.success('导出成功');
        setLogListDot(true);
      }
    },
    setDetailVisible(visible) {
      marketingLaunchManage.setState({ detailVisible: visible });
    },
    // tabs
    onTabsChange(type) {
      const { detailParams } = getState().marketingLaunchManage;
      marketingLaunchManage.setState({
        detailParams: {
          ...detailParams,
          cur_page: 1,
          type,
        },
      });
    },
    // 翻页
    onDetailNav(page) {
      const { detailParams } = getState().marketingLaunchManage;
      marketingLaunchManage.setState({ detailParams: { ...detailParams, cur_page: page } });
    },
    // 重置详情项
    onDetailReset() {
      marketingLaunchManage.setState({
        detailParams: {
          per_page: 20,
          cur_page: 1,
          detail_status: 'all',
        },
      });
    },
    // 创建、编辑平台券
    setAddEditType(type) {
      marketingLaunchManage.setState({ addEditType: type });
    },
    setInitData(data) {
      marketingLaunchManage.setState({ initData: data });
    },
    async setRelease(values, couponTableData, releaseNum, history, releaseId) {
      let hasZeroCoupon = false;
      couponTableData.forEach((coupon) => {
        if (!releaseNum[coupon.key] || releaseNum[coupon.key] === 0) {
          hasZeroCoupon = true;
        }
      });
      if (hasZeroCoupon) {
        message.error('优惠券投放数量不能为0');
        return;
      }
      const { addEditType } = getState().marketingLaunchManage;
      const { union_shop_id, shop_id } = getState().basic;
      const params = {
        unionShopId: union_shop_id,
        shopId: shop_id,
        releaseName: values.releaseName,
        releaseMethod: values.releaseMethod,
        type: values.type,
        platformLimit: 0,
        allLimitPreDay: values.allLimitPreDay,
        platformCoupons: JSON.stringify(
          couponTableData.map((data) => ({
            platform_coupon_batch_id: data.key,
            num: releaseNum[`${data.key}`],
          })),
        ),
        startTime: values.rangeTime[0].valueOf(),
        endTime: values.rangeTime[1].valueOf(),
      };
      switch (values.type) {
        case typeEnums.company.value:
          params.releaseRange = JSON.stringify(
            values.releaseRange.map((range) => ({
              company_id: range.key,
            })),
          );
          break;
        case typeEnums.people.value:
          params.releaseRange = JSON.stringify(
            values.releaseRange.map((range) => ({
              user_id: range.key,
            })),
          );
          params.sendMsg = Number(values.sendMsg);
          break;
        case typeEnums.newPeople.value:
          params.companyBlacklist = JSON.stringify(
            (values.releaseRange || []).map((range) => range.key),
          );
          params.newUserTime = values.newUserTime;
          break;
        case typeEnums.oldPeople.value:
          params.oldUserRule = JSON.stringify({
            day: values.day,
            minOrderNum: values.minOrderNum,
            maxOrderNum: values.maxOrderNum,
          });
          break;
        // 全部用户
        case typeEnums.allPeople.value:
          params.companyBlacklist = JSON.stringify(
            (values.releaseRange || []).map((range) => range.key),
          );
          break;
        // 人群包
        case typeEnums.package.value:
          params.releaseRange = (values.packages || []).join(',');
          break;
        default:
          break;
      }
      if (addEditType === 'edit') {
        params.releaseId = releaseId;
      }
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/releaseset', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        if (addEditType === 'edit') {
          message.success('投放修改成功');
        } else {
          message.success('投放创建成功');
        }
        history.push('/marketing/launch-manage');
        marketingLaunchManage.setState({ initData: {} });
      }
    },
    async getBusiness(value) {
      marketingLaunchManage.setState({
        rangeData: [],
        rangeDataFetching: true,
      });
      const params = {
        auditResult: 2, // 	审核状态 1：待处理、2：通过、3：不通过 4：停用
        pageSize: 10000, // 获取全部数据，不改动后端公共接口
      };
      // 判断ID或者名称
      if (Number.isNaN(Number(value))) {
        params.parentCompanyName = value;
      } else if (value) {
        params.companyId = value;
      }
      const data = await fetch('/saasmerchant/web/fscompany/getCompanyListByIdOrKeyName', {
        type: 'POST',
        useJson: true,
        params: filterNull(params),
      });
      if (data) {
        const rangeData = data.companyVos?.map((d) => ({
          label: `${d.subCompanyName}-${d.companyId}`,
          id: d.companyId,
        }));
        marketingLaunchManage.setState({ rangeData });
      }
      marketingLaunchManage.setState({ rangeDataFetching: false });
    },
    clearRangeData() {
      marketingLaunchManage.setState({ rangeData: [] });
    },
    async getCoupon(value) {
      const { union_shop_id, shop_id } = getState().basic;
      const { couponResNum } = getState().marketingLaunchManage;
      marketingLaunchManage.setState({
        couponData: [],
        couponDataFetching: true,
      });
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/search', {
        type: 'GET',
        params: filterNull({
          search: value,
          unionShopId: union_shop_id,
          shopId: shop_id,
        }),
      });
      if (data) {
        const couponData = data.map((d) => ({
          label: d.platformCouponName,
          id: d.platformCouponBatchId,
        }));
        data.forEach((d) => {
          couponResNum[d.platformCouponBatchId] = d.surplusAmount;
        });
        marketingLaunchManage.setState({ couponData, couponResNum });
      }
      marketingLaunchManage.setState({ couponDataFetching: false });
    },
    clearCouponResNum() {
      marketingLaunchManage.setState({ couponResNum: {} });
    },
    clearCouponData() {
      marketingLaunchManage.setState({ couponData: [] });
    },
    /** 编辑时获取优惠券剩余张数 */
    async getPlatformCouponSurplus(releaseId) {
      const data = await fetch(
        '/saasmerchant/web/coupon/platformCoupons/getPlatformCouponSurplus',
        {
          type: 'GET',
          params: { releaseId },
        },
      );
      if (data) {
        marketingLaunchManage.setState({ couponResNum: data });
      }
    },
    async getPeople(value) {
      const { union_shop_id, shop_id } = getState().basic;
      marketingLaunchManage.setState({
        rangeData: [],
        rangeDataFetching: true,
      });
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/searchemployee', {
        type: 'GET',
        params: filterNull({
          phone: value,
          unionShopId: union_shop_id,
          shopId: shop_id,
        }),
      });
      if (data) {
        const rangeData = data.map((d) => ({
          label: `${d.companyName || ' '}-${d.customerGroupName || ' '}-${d.employeeName || ''}-${
            d.employeePhone || d.phone
          }`,
          id: d.userId,
          ...d,
        }));
        marketingLaunchManage.setState({ rangeData });
      }
      marketingLaunchManage.setState({ rangeDataFetching: false });
    },
    clearPeopleData() {
      marketingLaunchManage.setState({ rangeData: [] });
    },
    // 投放详情
    async getRangeDetailList(releaseId) {
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/getReleaseRanges', {
        type: 'GET',
        params: { releaseId },
      });
      return data;
    },
    // 获取详情弹窗企业黑名单
    async getReleaseBlackCompany(releaseId) {
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/getReleaseBlackCompany', {
        type: 'GET',
        params: { releaseId },
      });
      return data;
    },
    // 获取详情弹窗投送优惠券
    async getPlatformCouponRecord(releaseId) {
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/getReleaseRecord', {
        type: 'GET',
        params: { releaseId },
      });
      return data;
    },
    async postApprovalDetail(params) {
      const data = await fetch('/saasmerchant/web/coupon/platformCoupons/releaseApprove', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    async getPackageList() {
      const data = await fetch('/saasmerchant/web/crm/user/package/baseInfo/list', {
        type: 'GET',
        params: {
          packageName: '',
        },
      });
      return data;
    },
  }),
};

export default model;
